import React from 'react';
import styles from './contextMenu.module.css';
import { Button } from '../inputs/button';
import { useEffect } from 'react';
import { useShown } from '../../../services/hooks/useShown';
import { useWindowSize } from '../../../services/hooks/useWindowSize';
import { useState } from 'react';
import { Portal } from '../portal/portal';

const ContextMenuWidth = 250;
const ContextMenuItemHeight = 45;
const ContextMenuSpaceHeight = 6;
//                                  No bottom margin on the last item
const ContextMenuPaddingHeight = 16 - 4;
const ContextMenuEdgePadding = 4;

export const ContextMenu = ({actions, x = 0, y = 0, show = true, onClose = () => {}}) => {

    const { ref, shown, setShown } = useShown(show);
    const [pos, setPos] = useState({x: x, y: y});
    const { windowSize } = useWindowSize();

    useEffect(() => {
        setShown(show);
    }, [show]);

    useEffect(() => {
        if (!shown) 
            onClose();
    }, [shown]);

    useEffect(() => {
        setPos({
            x: Math.max(Math.min(x, windowSize.width - ContextMenuWidth - ContextMenuEdgePadding), ContextMenuEdgePadding),
            y: Math.max(Math.min(y, windowSize.height - height() - ContextMenuEdgePadding), ContextMenuEdgePadding)
        })
    }, [x, y, actions]);

    const height = () => actions.reduce((a, b) => {
        a += (b.isSpacer) ? ContextMenuSpaceHeight : ContextMenuItemHeight;
        return a;
    }, ContextMenuPaddingHeight);


    return <Portal>
        <div
            ref={ref}
            className={styles.Menu + (shown ? ' ' + styles.Show : '')}
            style={{
                top: pos.y + 'px',
                left: pos.x + 'px'
            }}
        >
            {
                actions.map((a, i) => (
                    a.isSpacer ?
                    <hr key={'Spacer' + i} />
                    :
                    <Button key={a.label + i} className={styles.Item} onClick={(e) => { setShown(false); return a.onClick(e); }}>
                        <div className={styles.Icon + ' icon'}>{a.icon}</div>
                        <div className={styles.Label}>{a.label}</div>
                    </Button>
                ))
            }
        </div>
    </Portal>
}